import React, { useState } from 'react';
import { Flag } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '@/lib/utils';
import { ReportDialog } from './ReportDialog';
import { useToast } from '../ui/use-toast';

interface ReportButtonProps {
  contentId: string;
  contentType: 'topic' | 'reply';
  variant?: 'icon' | 'text' | 'menu';
  className?: string;
}

export const ReportButton: React.FC<ReportButtonProps> = ({
  contentId,
  contentType,
  variant = 'icon',
  className
}) => {
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const { toast } = useToast();

  const handleReportSuccess = () => {
    toast({
      title: "Report submitted",
      description: "Thank you for helping keep our community safe. We'll review your report.",
      variant: "default",
    });
  };

  if (variant === 'menu') {
    return (
      <>
        <div
          onClick={(e) => {
            e.stopPropagation();
            setIsReportDialogOpen(true);
          }}
          className={cn(
            "flex items-center cursor-pointer text-red-500",
            "hover:bg-dark-400",
            className
          )}
        >
          <Flag className="h-4 w-4 mr-2" />
          Report
        </div>
        
        <ReportDialog
          isOpen={isReportDialogOpen}
          onClose={() => setIsReportDialogOpen(false)}
          contentId={contentId}
          contentType={contentType}
          onSuccess={handleReportSuccess}
        />
      </>
    );
  }

  if (variant === 'text') {
    return (
      <>
        <Button
          variant="ghost"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            setIsReportDialogOpen(true);
          }}
          className={cn(
            "text-dark-800 hover:text-red-500 hover:bg-transparent",
            className
          )}
        >
          <Flag className="h-4 w-4 mr-1" />
          <span>Report</span>
        </Button>
        
        <ReportDialog
          isOpen={isReportDialogOpen}
          onClose={() => setIsReportDialogOpen(false)}
          contentId={contentId}
          contentType={contentType}
          onSuccess={handleReportSuccess}
        />
      </>
    );
  }

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={(e) => {
          e.stopPropagation();
          setIsReportDialogOpen(true);
        }}
        className={cn(
          "h-8 w-8 text-dark-800 hover:text-red-500 hover:bg-transparent",
          className
        )}
        title="Report"
      >
        <Flag className="h-4 w-4" />
      </Button>
      
      <ReportDialog
        isOpen={isReportDialogOpen}
        onClose={() => setIsReportDialogOpen(false)}
        contentId={contentId}
        contentType={contentType}
        onSuccess={handleReportSuccess}
      />
    </>
  );
};